import React from 'react';

interface Props {
    className?: string;
}

export const CoachDollar: React.FC<Props> = ({ className }) => {
    return (
        <svg
            className={`icon${className ? ` ${className}` : ''}`}
            width="136.891"
            height="169.719"
            viewBox="0 0 136.891 169.719"
        >
            <g id="Group_173" data-name="Group 173" transform="translate(0)">
                <g id="Group_172" data-name="Group 172" className="cls-2" transform="translate(0)">
                    <path
                        id="Path_68"
                        data-name="Path 68"
                        className="cls-3"
                        d="M21.665,73.651h3.592a7.183,7.183,0,0,0,6.935-5.314,38.27,38.27,0,0,0,7.754,11.983,25.715,25.715,0,0,1,2.51-2.587,28.991,28.991,0,0,1,5.238-3.669,28.506,28.506,0,1,1,40.6-.522A54.327,54.327,0,0,1,97.2,78.47a38.383,38.383,0,0,0,6.11-10.132,7.183,7.183,0,0,0,6.932,5.317h3.59a7.187,7.187,0,0,0,7.185-7.185V42.433a7.186,7.186,0,0,0-7.185-7.185h-3.408a43.46,43.46,0,0,0-85.352,0H21.665a7.187,7.187,0,0,0-7.185,7.185V66.466a7.187,7.187,0,0,0,7.185,7.185M67.75,11.2A32.281,32.281,0,0,1,95.884,27.7a38.381,38.381,0,0,0-54.24-2.028q-1.052.976-2.028,2.028A32.28,32.28,0,0,1,67.75,11.2"
                        transform="translate(0.696 0)"
                    />
                    <path
                        id="Path_69"
                        data-name="Path 69"
                        className="cls-3"
                        d="M106.8,96.664h-32v5.088a59.256,59.256,0,0,1,12.031,4.821H106.8a16.6,16.6,0,0,1,16.584,16.584v21H96.649a25.831,25.831,0,0,1-4.253,4.926,30.587,30.587,0,0,1-7.83,4.984H133.3V123.159A26.494,26.494,0,0,0,106.8,96.664"
                        transform="translate(3.594 4.644)"
                    />
                    <path
                        id="Path_70"
                        data-name="Path 70"
                        className="cls-3"
                        d="M47.507,152.948a59.673,59.673,0,0,1-14.29-8.535l-.315-.254H9.91v-21a16.6,16.6,0,0,1,16.584-16.585H38.538a24.109,24.109,0,0,1-3.484-9.909H26.495A26.494,26.494,0,0,0,0,123.159V154.07H50.4q-1.46-.525-2.889-1.121"
                        transform="translate(0 4.644)"
                    />
                    <path
                        id="Path_71"
                        data-name="Path 71"
                        className="cls-4"
                        d="M72.557,106.537V83.693a41.251,41.251,0,0,1,16.352,7.695l6.734-11.3a50.507,50.507,0,0,0-10.52-6.013,46.529,46.529,0,0,0-12.084-3.125V63.733H62.577v6.974A36.8,36.8,0,0,0,52.3,72.991a26.069,26.069,0,0,0-8,4.809,20.668,20.668,0,0,0-5.171,7.033,21.4,21.4,0,0,0-1.8,8.838v.24q0,10.1,6.253,15.692t19.479,8.958v23.566a36.824,36.824,0,0,1-10.942-3.548A58.541,58.541,0,0,1,41.9,131.789L34.2,142.729a55.181,55.181,0,0,0,13.286,7.936,56.141,56.141,0,0,0,15.09,3.969v12.023H73.038v-11.9A36.38,36.38,0,0,0,83.5,152.41a26.9,26.9,0,0,0,8.056-4.87,21.4,21.4,0,0,0,5.23-7.034,21.077,21.077,0,0,0,1.863-8.958v-.24q0-9.618-6.192-15.45t-19.9-9.32m-9.5-2.525q-6.974-2.042-9.258-4.629a9.186,9.186,0,0,1-2.284-6.312v-.24A8.977,8.977,0,0,1,54.4,86.1q2.886-2.765,8.658-3.247Zm21.4,28.377a8.944,8.944,0,0,1-3.067,7.034q-3.066,2.706-8.837,3.186V120.846q6.971,2.047,9.438,4.69a9.327,9.327,0,0,1,2.466,6.613Z"
                        transform="translate(1.643 3.062)"
                    />
                </g>
            </g>
        </svg>
    );
};
